let language = {
    "A110B001": '同步失败',
    "A110B002": '同步成功',
    "A110B003": "同步此产品到您的在线电子商店时发生错误。您可以点击 [同步] 再次尝试同步，或点击 [稍后] 稍后同步？",
    "A110B004": "激活店铺产品成功！",
    "A110B005": "取消激活店铺产品成功！",
    "A110B006": "失败",
    "A110B007": "激活此产品时发生错误，请稍后再试。",
    "A110B008": "将此产品设置为离线时发生错误，请稍后再试。",
    "A110B009": "同步此产品到您的在线电子商店时发生错误，请稍后同步。",
    "A110B010": "激活产品成功",
    "A110B011": "取消激活产品成功",
    "A110B012": "您已成功修改店铺产品状态。接下来，您可以将此产品同步到您的在线电子商店。点击 [同步] 立即同步或点击 [稍后] 稍后同步。",
    "A110B013": "激活店铺产品",
    "A110B014": "将您的产品设置为激活，此产品将显示在您的在线电子商店中，您确定要激活它吗？",
    "A110B015": "取消激活店铺产品",
    "A110B016": "将此产品设置为不活跃，此产品将在您的在线电子商店中下线，您确定要将其设置为不活跃吗？",
    "A110B017": "店铺产品状态已更改为活跃，您可以在您的在线电子商店中查看店铺产品。",
    "A110B018": "店铺产品状态已更改为不活跃，您无法在您的在线电子商店中查看店铺产品。",
    "A110B019": "店铺产品状态已成功修改。店铺产品正在同步，请稍后刷新页面以查看同步结果。",
    "A110B020": "店铺产品状态已成功修改。当前店铺无法连接到woocommerce，请检查您的woocommerce连接状态。",
    "A110B021": "店铺产品状态已成功修改。当前店铺不存在该产品所属的店铺。",
    "A110B022": "选择产品",
    "A110B023": "当前选择的店铺产品为空，请选择您要复制的店铺产品。",
    "A110B024": "复制成功",
    "A110B025": "您想留在此页面，还是前往目标店铺查看结果？",
    "A110B026": "选择店铺",
    "A110B027": "当前选择的店铺为空，请选择您要复制产品的店铺。",
    "A110B028": "复制成功",
    "A110B029": "复制失败",
    "A110B030": "店铺产品已复制到指定店铺。但店铺产品正在同步，请稍后刷新页面以查看同步结果。",
    "A110B031": "店铺产品已复制到指定店铺。但当前店铺无法连接到woocommerce，请检查您的woocommerce连接状态。",
    "A110B032": "店铺产品已复制到指定店铺。但当前店铺不存在该产品所属的店铺。",
    "A110B033": "店铺产品已复制到指定店铺。但同步店铺产品到您的在线电子商店时发生错误。",
    "A110B034": "删除项目",
    "A110B035": "未选择任何项目。",
    "A110B036": "删除店铺产品？",
    "A110B037": "删除店铺产品后，将不会在您的在线电子商店中找到它，您确定要删除它吗？",
    "A110B038": "删除成功",
    "A110B039": "删除失败",
    "A110B040": "您确定要删除该产品吗？",
    "A110B041": "未选择店铺产品",
    "A110B042": "请检查店铺产品备份以同步店铺产品。",
    "A110B043": "同步此产品时发生错误，请重试或联系技术支持 {{supportmail}}。",
    "A110B044": "同步此产品时上传图片失败，请重试或联系技术支持 {{supportmail}}。",
    "A110B045": "同步此产品时网络连接超时，请重试并再次尝试。",
    "A110B046": "同步店铺产品",
    "A110B047": "多次检查店铺产品同步状态，但仍有店铺产品正在同步。是否需要继续更新店铺产品同步状态？",
    "A110B048": "发生错误，请刷新页面并重试。",
    "A110P001": "店铺产品图片缺失。",
    "A110P002": "店铺产品名称缺失。",
    "A110P003": "缺少产品信息。",
    STORE_PRODUCT_ADD_TO_CART_TITLE: "添加到购物车",
    STORE_PRODUCT_ADD_TO_CART_CONTENT: "该商品将添加到您的购物车中",
    STORE_PRODUCT_ADD_TO_CART_ERROR_TITLE: "添加购物车异常",
    STORE_PRODUCT_ADD_TO_CART_ERROR_CONTENT: "产品添加到购物车时出现问题。请您点击 \"{{retryBtn}}\" 重试，如果问题依然存在, 您可以联系我们的技术团队 {{supportmail}}。",
    STORE_PRODUCT_ADD_TO_CART_ERROR_CONTENT2: "产品添加到购物车时出现问题。请您重试，如果问题依然存在, 您可以联系我们的技术团队{{supportmail}}。",
    STORE_PRODUCT_ADD_TO_CART_UNKNOWN_ERROR:"将产品添加到购物车时出错。请刷新页面并重试。如果问题仍然存在，请通过 {{supportmail}} 联系我们。",
    STORE_PRODUCT_PRODUCT_DETAIL_ERROR_TITLE: "产品详情跳转问题",
    STORE_PRODUCT_PRODUCT_DETAIL_ERROR_CONTENT: "前往产品详情页出现问题.  请您重试，如果问题依然存在, 您可以联系我们的技术团队 {{supportmail}}。",
    "A110B049": "该产品尚未发布。请访问您的网站以发布该产品并供客户使用。",
    // 产品配置问题  
    "A110B2700401": "产品配置设置不正确。请刷新页面并重试。如果问题仍然存在，请联系我们：{{supportmail}}。",
    // 产品购买数量小于“最小购买数量”
    "A110B2700419": "订单数量小于最低订单数量。请调整数量并重试。如果问题仍然存在，请联系我们：{{supportmail}}",
    // 产品不是一个成品产品（产品未完成定制），无法添加到购物车
    "A110B200064": "产品设置尚未完成。请编辑并完成产品设置，然后重试。",
    // 产品计价问题
    "A110B1200001": "计算产品价格时出错。请刷新页面并重试。如果问题仍然存在，请联系我们：{{supportmail}}",
    
    STORE_PRODUCT_CURRENCY_INCONSISTENT_TIP: "产品计价货币与您商店的货币不同。",
    STORE_PRODUCT_CURRENCY_INCONSISTENT_UPDATE_TEXT: " 更新您的货币和定价。",
    STORE_PRODUCT_CURRENCY_CLICK_HERE: "点击这里",
    STORE_PRODUCT_CURRENCY_NOT_SUPPORT_TIP: "您的商店的货币不受支持。",
    STORE_PRODUCT_CURRENCY_NOT_SUPPORT_URL_TEXT: " 更改您商店的默认货币。",
    STORE_PRODUCT_COPY_STORE_PRODUCT_TITLE: "复制店铺产品",
    STORE_PRODUCT_COPY_STORE_PRODUCT_BY_UNSUPPORTED_PRODUCT_CONTENT:"您当前的选中项存在不支持复制的店铺产品，请您确认之后再进行操作。",
    STORE_PRODUCT_SYNCING_STORE_PRODUCT_TITLE: "同步店铺产品",
    STORE_PRODUCT_SYNCING_STORE_PRODUCT_BY_UNSUPPORTED_PRODUCT_CONTENT:"您当前的选中项存在不支持同步的店铺产品，请您确认之后再进行操作。",
};

export { language }
